import { render, staticRenderFns } from "./IconCircle.vue?vue&type=template&id=4284e2ec&"
import script from "./IconCircle.vue?vue&type=script&lang=js&"
export * from "./IconCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports